import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  StaticUrlType: { input: any; output: any; }
};

export type AcquiringDataType = {
  __typename?: 'AcquiringDataType';
  iban: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AcquiringType = {
  __typename?: 'AcquiringType';
  contactEmail: Scalars['String']['output'];
  /** @deprecated use saveAcquiringInfo mutation */
  onboardingUrl: Scalars['String']['output'];
};


export type AcquiringTypeOnboardingUrlArgs = {
  redirectUrl: Scalars['String']['input'];
};

export enum AdGuidelinesChoice {
  Description = 'description',
  Photo = 'photo',
  Size = 'size'
}

export type AdGuidelinesType = {
  __typename?: 'AdGuidelinesType';
  description: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AddProductToSwapType = {
  __typename?: 'AddProductToSwapType';
  errors?: Maybe<Array<GraphResponseError>>;
  retrieveExchangeCoin: Scalars['Boolean']['output'];
};

export type AppPayInfoType = {
  __typename?: 'AppPayInfoType';
  applePaySession: Scalars['String']['output'];
  gateway: Scalars['String']['output'];
  merchantId?: Maybe<Scalars['String']['output']>;
};


export type AppPayInfoTypeApplePaySessionArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


export type AppPayInfoTypeMerchantIdArgs = {
  deliveryService?: InputMaybe<DeliveryService>;
  paymentTerminal: PaymentTerminal;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ApproveSwapOrderType = {
  __typename?: 'ApproveSwapOrderType';
  errors?: Maybe<Array<GraphResponseError>>;
  order?: Maybe<SwapOrderType>;
};

export type AuthorizePlatformType = {
  __typename?: 'AuthorizePlatformType';
  /** Refresh token has expired. User must verify phone number */
  isExpired: Scalars['Boolean']['output'];
};

export type BestSellerInCategoryType = {
  __typename?: 'BestSellerInCategoryType';
  products: Array<ProductType>;
  seller: User;
};

export type BestSellersInCategoryType = {
  __typename?: 'BestSellersInCategoryType';
  bestSellers: Array<BestSellerInCategoryType>;
};

export type BlockedUsersType = {
  __typename?: 'BlockedUsersType';
  blockedUserIds?: Maybe<Array<Scalars['Int']['output']>>;
  errors?: Maybe<Array<GraphResponseError>>;
};

/** Type represents bonusback info for given product */
export type BonusbackInfoType = {
  __typename?: 'BonusbackInfoType';
  /** Bonus back text to display on product page. */
  amountText: Scalars['String']['output'];
  /** Text to display in bonus back info popup. */
  infoText: Scalars['String']['output'];
  popUp: Array<PopUpItemType>;
};

export type BrandFeedInfoType = {
  __typename?: 'BrandFeedInfoType';
  /** All important brands */
  brands: Scalars['JSON']['output'];
  /** Top brands to show with images */
  topBrands: Scalars['JSON']['output'];
};

/** Type represents products brands info. */
export type BrandType = {
  __typename?: 'BrandType';
  /** The internal brand id. */
  id: Scalars['Int']['output'];
  /** The url with brand's logo. */
  image?: Maybe<Scalars['String']['output']>;
  /** If brand is indexed, than it should have particular seo indexed link on products page with that brand filter */
  isIndexed: Scalars['Boolean']['output'];
  /** This field returns True if the brand is of Ukrainian origin. */
  isUkrainian: Scalars['Boolean']['output'];
  /** This field returns True if the current user has subscribed to this brand in the past. */
  isViewerSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** Title for current brand. */
  name: Scalars['String']['output'];
  /** Slug for current brand. */
  slug: Scalars['String']['output'];
  /** Title for current brand. */
  title: Scalars['String']['output'];
};


/** Type represents products brands info. */
export type BrandTypeIsIndexedArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
};

export type BrandTypeUserBrandType = BrandType | UserBrandType;

export enum CardConfirmationStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type CatalogCharacteristicFilterType = ThematicFilterType & {
  __typename?: 'CatalogCharacteristicFilterType';
  characteristicChoice: ProductCharacteristicChoiceType;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CatalogFilterType = {
  __typename?: 'CatalogFilterType';
  /** Characteristic id for filter type */
  filterEntityId?: Maybe<Scalars['ID']['output']>;
  type: FilterType;
};

export type CatalogType = {
  __typename?: 'CatalogType';
  breadcrumbs: Array<CatalogType>;
  /** Characteristic choices filters created by content managers */
  characteristicChoicesFilters: Array<CatalogCharacteristicFilterType>;
  /** Characteristics allowed in the catalog */
  characteristics: Array<ProductCharacteristicType>;
  /** Catalog children */
  children: Array<CatalogType>;
  descriptionGuide: Scalars['String']['output'];
  /** Used to properly order filters in UI. Only ordered filters are returned. If some filter isn't in the list, it should be placed below. */
  filterTypes: Array<CatalogFilterType>;
  id: Scalars['Int']['output'];
  indexedFilter?: Maybe<IndexedFilterType>;
  isAdultOnly: Scalars['Boolean']['output'];
  isAllowedPriceVariation: Scalars['Boolean']['output'];
  isColorRequired: Scalars['Boolean']['output'];
  /** Meta description is used in <meta name="description" /> tag */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** Meta title is used in <title> tag */
  metaTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  namespace: NamespaceType;
  /**
   * The redirect URL for the catalog, if any. This is an absolute URL **without** domain and localization prefix.If an active indexed filter is present when requesting the catalog, it should be appended to the redirect URL on the client side.
   * Note: this field does **not** return the redirect for the active indexed filter. For that, use `IndexedFilterType.redirect_to`.
   */
  redirectTo?: Maybe<Scalars['String']['output']>;
  /** SEO description is an html string that should be injected in the catalog page. It's not meta description and shouldn't be used in meta tags. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** SEO title is a string that should be used as <h1> on the catalog page. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  sizeGroup?: Maybe<SizeGroupType>;
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type CatalogTypeBreadcrumbsArgs = {
  forRecommendedCatalogs?: Scalars['Boolean']['input'];
};


export type CatalogTypeCharacteristicChoicesFiltersArgs = {
  forSeoHub?: Scalars['Boolean']['input'];
};


export type CatalogTypeCharacteristicsArgs = {
  hideInternal?: Scalars['Boolean']['input'];
};


export type CatalogTypeIndexedFilterArgs = {
  input?: InputMaybe<IndexedFilterInput>;
};


export type CatalogTypeMetaDescriptionArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  indexedFilter?: InputMaybe<IndexedFilterInput>;
};


export type CatalogTypeMetaTitleArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  indexedFilter?: InputMaybe<IndexedFilterInput>;
};


export type CatalogTypeSeoDescriptionArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  indexedFilter?: InputMaybe<IndexedFilterInput>;
};


export type CatalogTypeSeoTitleArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  indexedFilter?: InputMaybe<IndexedFilterInput>;
};

export type ChangeReceivingPaymentMethodType = {
  __typename?: 'ChangeReceivingPaymentMethodType';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type ChangeShowPhoneNumberType = {
  __typename?: 'ChangeShowPhoneNumberType';
  errors?: Maybe<Array<GraphResponseError>>;
  user: ViewerType;
};

export type ChatBotMetaType = {
  __typename?: 'ChatBotMetaType';
  hash: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Type represents city information */
export type CityType = {
  __typename?: 'CityType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** City name in where case as answer on question 'where' (Київ->Києві, Рівне->Рівному) */
  nameWhere?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export enum ColorEnum {
  Beige = 'BEIGE',
  Black = 'BLACK',
  Blue = 'BLUE',
  Brown = 'BROWN',
  Burgundy = 'BURGUNDY',
  Coral = 'CORAL',
  Cyan = 'CYAN',
  Golden = 'GOLDEN',
  Gray = 'GRAY',
  Green = 'GREEN',
  Khaki = 'KHAKI',
  LightGreen = 'LIGHT_GREEN',
  Lilac = 'LILAC',
  Multicolor = 'MULTICOLOR',
  Mustard = 'MUSTARD',
  Orange = 'ORANGE',
  Peach = 'PEACH',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Silver = 'SILVER',
  Turquoise = 'TURQUOISE',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export type ColorFilterType = {
  __typename?: 'ColorFilterType';
  enum: ColorEnum;
  hex: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** If color is indexed, than it should have particular seo indexed link on products page with that color filter */
  isIndexed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};


export type ColorFilterTypeIsIndexedArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
};

export type CommentCreateType = {
  __typename?: 'CommentCreateType';
  comment?: Maybe<CommentType>;
  errors?: Maybe<Array<GraphResponseError>>;
};

export type CommentDeleteType = {
  __typename?: 'CommentDeleteType';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type CommentLikeType = {
  __typename?: 'CommentLikeType';
  comment?: Maybe<CommentType>;
  errors?: Maybe<Array<GraphResponseError>>;
};

/** Information related to the comment for the current post */
export type CommentType = {
  __typename?: 'CommentType';
  /** author's ID of the current comment. */
  authorId: Scalars['String']['output'];
  /** this is id of parent comment in the reply */
  commentId?: Maybe<Scalars['String']['output']>;
  /** number of comments in the reply for the current comment. */
  commentsCount: Scalars['Int']['output'];
  /** date of creating for the current comment. */
  createdAt: Scalars['DateTime']['output'];
  /** id of the current comment. */
  id: Scalars['String']['output'];
  /** True if current user liked this comment. */
  isLiked: Scalars['Boolean']['output'];
  /** number of likes for the current comment. */
  likesCount: Scalars['Int']['output'];
  /** ID of the post for which the comment was created */
  postId: Scalars['String']['output'];
  /** main text for the current comment. */
  text: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type CommentTypeConnectionProxy = {
  __typename?: 'CommentTypeConnectionProxy';
  /** Contains the nodes in this connection */
  edges: Array<CommentTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CommentTypeEdge = {
  __typename?: 'CommentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CommentType;
};

export type CommentUnlikeType = {
  __typename?: 'CommentUnlikeType';
  comment?: Maybe<CommentType>;
  errors?: Maybe<Array<GraphResponseError>>;
};

export enum ConditionEnum {
  Alright = 'ALRIGHT',
  Good = 'GOOD',
  Ideal = 'IDEAL',
  New = 'NEW',
  VeryGood = 'VERY_GOOD'
}

export type ConditionFilterType = {
  __typename?: 'ConditionFilterType';
  enum: ConditionEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CreateOrderPurchaseType = {
  __typename?: 'CreateOrderPurchaseType';
  approveUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<GraphResponseError>>;
};

export type CreateSwapOrderType = {
  __typename?: 'CreateSwapOrderType';
  errors?: Maybe<Array<GraphResponseError>>;
  order?: Maybe<SwapOrderType>;
};

export type CreateUserBrandType = {
  __typename?: 'CreateUserBrandType';
  brand?: Maybe<UserBrandType>;
  errors?: Maybe<Array<GraphResponseError>>;
};

export type DeclineSwapOrderBySellerInfoType = {
  __typename?: 'DeclineSwapOrderBySellerInfoType';
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DeclineSwapOrderType = {
  __typename?: 'DeclineSwapOrderType';
  errors?: Maybe<Array<GraphResponseError>>;
  order?: Maybe<SwapOrderType>;
};

export type DeliveryCityType = {
  __typename?: 'DeliveryCityType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DeliveryInfoType = {
  __typename?: 'DeliveryInfoType';
  city: LocationInfoType;
  defaultPrice: Scalars['Int']['output'];
  deliveryService: DeliveryService;
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  minTariff: Scalars['String']['output'];
  name: Scalars['String']['output'];
  region: LocationInfoType;
  smartDescription: Scalars['String']['output'];
  smartPostomateDescription: Scalars['String']['output'];
  warehouse: LocationInfoType;
};

export enum DeliveryService {
  Justin = 'JUSTIN',
  Meest = 'MEEST',
  NovaPoshta = 'NOVA_POSHTA',
  Rozetka = 'ROZETKA',
  UkrPoshta = 'UKR_POSHTA'
}

export type DeliveryServiceDetailType = {
  __typename?: 'DeliveryServiceDetailType';
  city?: Maybe<DeliveryCityType>;
  defaultPrice: Scalars['String']['output'];
  deliveryService: DeliveryService;
  description: Scalars['String']['output'];
  icon: Scalars['StaticUrlType']['output'];
  name: Scalars['String']['output'];
  smartDescription?: Maybe<Scalars['String']['output']>;
  smartPostomateDescription?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<WarehouseType>;
};

/** Information about payment card */
export type EvoCardsInfoType = {
  __typename?: 'EvoCardsInfoType';
  /** Image of the bank if can be acquired */
  bankImage: Scalars['String']['output'];
  /**
   * Card holder id, this is used for most operations
   * @deprecated Deprecated. Use card_id instead
   */
  cardHolderId: Scalars['String']['output'];
  /** Mask of the card *** 1430 */
  cardMask: Scalars['String']['output'];
  /** Date of expiration for card */
  expiresAt: Scalars['String']['output'];
  /** Card id */
  id: Scalars['String']['output'];
  /** Is the current card selected as a default */
  isDefault: Scalars['String']['output'];
  /** Whether card expired */
  isExpired: Scalars['Boolean']['output'];
  /** true if card added in another project (prom, izi, crafta, ...) */
  isExternal: Scalars['Boolean']['output'];
  /** Type of the card Visa/Mastercard */
  type: Scalars['String']['output'];
};

export type FeatureFlagsType = {
  __typename?: 'FeatureFlagsType';
  PRODUCTDetailsSpaEnabled: Scalars['Boolean']['output'];
  SHAF18704NewTopProductsAlgorithm: Scalars['Boolean']['output'];
  SHAF19305NewBuyerAb: Scalars['Boolean']['output'];
  SHAF19375ScoreFormulaTest: Scalars['Boolean']['output'];
  SHAF19434GoogleOneTapLoginEnabled: Scalars['Boolean']['output'];
  SHAF19515NewPhoneNumberReveal: Scalars['Boolean']['output'];
  SHAF19621CheckoutAuthorizationEnabled: Scalars['Boolean']['output'];
  SHAF19654KviAb: Scalars['Boolean']['output'];
  SHAF20278CheckoutRequiredEmailEnabled: Scalars['Boolean']['output'];
  SHAF20305ScoreFormula7Test: Scalars['Boolean']['output'];
  SHAF20467ScoreFormula8Test: Scalars['Boolean']['output'];
  SHAF21020BalanceAppPayEnabled: Scalars['Boolean']['output'];
  SHAF21020OrderAppPayEnabled: Scalars['Boolean']['output'];
  SHAF21020PromotionAppPayEnabled: Scalars['Boolean']['output'];
  SHAF21020SmartAppPayEnabled: Scalars['Boolean']['output'];
  checkQuantityForNewState: Scalars['Boolean']['output'];
  /** @deprecated AB test complete, flag permanently enabled */
  enableDiscountPagePersonalized: Scalars['Boolean']['output'];
  /** @deprecated Test is completed, flag is always true */
  multiplePriceChangeEnabled: Scalars['Boolean']['output'];
  schoolSaleEnabled: Scalars['Boolean']['output'];
  smartOneClick: Scalars['Boolean']['output'];
  /** @deprecated Test is completed, flag is always true */
  splitRefundEnabled: Scalars['Boolean']['output'];
  staticABTestFlag: Scalars['Boolean']['output'];
};

export enum FilterType {
  Brand = 'BRAND',
  Characteristic = 'CHARACTERISTIC',
  City = 'CITY',
  Color = 'COLOR',
  Condition = 'CONDITION',
  Price = 'PRICE',
  Size = 'SIZE'
}

export type GlobalSettingsType = {
  __typename?: 'GlobalSettingsType';
  featureFlags: FeatureFlagsType;
};

export type GoogleAuthResponseType = {
  __typename?: 'GoogleAuthResponseType';
  authToken?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<GraphResponseError>>;
  user?: Maybe<ViewerType>;
};

export type GraphErrorMessage = {
  __typename?: 'GraphErrorMessage';
  /** error code */
  code: Scalars['String']['output'];
  /** error message */
  message: Scalars['String']['output'];
};

export type GraphResponseError = {
  __typename?: 'GraphResponseError';
  /** field where error occurred or `__all__` if field does not exist */
  field: Scalars['String']['output'];
  /** List of error message objects */
  messages: Array<GraphErrorMessage>;
  /** error payload */
  payload?: Maybe<Scalars['String']['output']>;
};

export type IndexedFilterInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  characteristicChoiceId?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['ID']['input']>;
};

export type IndexedFilterType = {
  __typename?: 'IndexedFilterType';
  canonicalTo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  redirectTo?: Maybe<Scalars['String']['output']>;
};

/** Type of indexed filter. */
export enum IndexedFilterTypeEnum {
  Brand = 'BRAND',
  Characteristic = 'CHARACTERISTIC',
  Color = 'COLOR'
}

export type InitiateReturnProcessType = {
  __typename?: 'InitiateReturnProcessType';
  errors?: Maybe<Array<GraphResponseError>>;
};

/** Contains card info and its confirmation status */
export type IsCardConfirmedInfoType = {
  __typename?: 'IsCardConfirmedInfoType';
  card: EvoCardsInfoType;
  confirmationStatus: CardConfirmationStatus;
};

/** Wrapper for liked post. */
export type LikedPostType = {
  __typename?: 'LikedPostType';
  /** id which u need to use for pagination */
  id: Scalars['String']['output'];
  /** The liked post. */
  post: PostType;
};

/** A connection to a list of items. */
export type LikedPostTypeConnectionProxy = {
  __typename?: 'LikedPostTypeConnectionProxy';
  /** Contains the nodes in this connection */
  edges: Array<LikedPostTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LikedPostTypeEdge = {
  __typename?: 'LikedPostTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: LikedPostType;
};

export type LocationInfoType = {
  __typename?: 'LocationInfoType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LoginByOtpType = {
  __typename?: 'LoginByOtpType';
  authToken?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<GraphResponseError>>;
  signedUserId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<ViewerType>;
};

/** Represented information related to project logo. */
export type LogoImageType = {
  __typename?: 'LogoImageType';
  /** The logo image url for android devices. */
  imageAndroid: Scalars['String']['output'];
  /** The logo image url for ios devices. */
  imageIos: Scalars['String']['output'];
  /** The logo image url for web browsers. */
  imageWeb: Scalars['String']['output'];
  /** If value is True then we need to show current logo instead default */
  isActive: Scalars['Boolean']['output'];
  /** The logo image url for web browsers. */
  title: Scalars['String']['output'];
};

export type LookupCardInfoType = {
  __typename?: 'LookupCardInfoType';
  /** Card identifier */
  cardId?: Maybe<Scalars['String']['output']>;
  /** Confirmation url to 3DS */
  confirmationUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<GraphResponseError>>;
};

/** The container for the all information related to the corresponding slide. */
export type MainBannerSlideType = {
  __typename?: 'MainBannerSlideType';
  id: Scalars['Int']['output'];
  /** The main image of the the current slide. */
  image: SlideImageType;
  /** The image that should be used on the product details screen */
  productDetailsImage: SlideImageType;
  /** Slide title, can be used as description for image if last one can't be loaded */
  title: Scalars['String']['output'];
  /** url for the link button related to current slide */
  url: Scalars['String']['output'];
};

/** Return information related to banner on the main page. */
export type MainBannerType = {
  __typename?: 'MainBannerType';
  /** filter by right banners type mobile/web */
  forMobileApps: Scalars['Boolean']['output'];
  /** filter by right banners type 'thank_you_page' */
  forThankYouPage: Scalars['Boolean']['output'];
  /** Return list of banner's slides. */
  slides: Array<MainBannerSlideType>;
};

export type MarkEvoCardAsDefaultInfoType = {
  __typename?: 'MarkEvoCardAsDefaultInfoType';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type MessageToSubscribersType = {
  __typename?: 'MessageToSubscribersType';
  /** Indicated if the user can send push/email message to subscribers */
  canSendMessage: Scalars['Boolean']['output'];
  /** Number of days before next message attempt */
  daysDelay: Scalars['Int']['output'];
  /** Number of symbols restriction */
  maximumNumberOfSymbols: Scalars['Int']['output'];
  /** Date when user can send next message */
  nextTimeCanSendAt?: Maybe<Scalars['Date']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   *
   *
   * **Auto Errors:**
   *
   * `invalid` - AddToSwapError
   */
  addProductToSwap: AddProductToSwapType;
  approveSwapOrder: ApproveSwapOrderType;
  /**
   *
   * Block user
   *
   */
  blockUser: BlockedUsersType;
  /**
   *
   * Errors:
   *     - card_does_not_exist - Card does not exist
   *     - at_least_one_product_required - At least one product is required
   *     - acquiring_info_does_not_exist - Acquiring info does not exist
   *     - acquiring_in_progress - Acquiring info is in progress
   *
   */
  changeReceivingPaymentMethod: ChangeReceivingPaymentMethodType;
  /**
   *
   * Change whether seller phone number is shown to new buyers.
   * Errors:
   *     No errors expected
   *
   */
  changeShowPhoneNumber: ChangeShowPhoneNumberType;
  /**
   *
   * Create comment errors:
   *
   * - Post doesn't exist - if post with current id doesn't exist
   * - Comment text is required - the body must not be empty
   *
   */
  commentCreate: CommentCreateType;
  /**
   *
   * Delete comment errors:
   *
   * - Comment doesn't exist - if comment with current id doesn't exist
   * - Comment deletion is forbidden - use can't delete comment
   *
   */
  commentDelete: CommentDeleteType;
  /**
   *
   * Add like for comment errors:
   *
   * - Comment doesn't exist (unknown) - if u try like comment which
   *   doesn't exist
   *
   */
  commentLike: CommentLikeType;
  /**
   *
   * Remove like for comment errors:
   *
   * - Comment doesn't exist (unknown) - if u try unlike comment which
   *   doesn't exist
   *
   */
  commentUnlike: CommentUnlikeType;
  createOrderPurchase: CreateOrderPurchaseType;
  /**
   *
   * Create SWAP order.
   * Errors:
   *   - not_enough_coins - Not enough coins to create SWAP order.
   *   - not_enough_money - Not enough money to charge order commission.
   *   `payload` - has amount to refill balance
   *
   */
  createSwapOrder: CreateSwapOrderType;
  /**
   *
   *     Create user brand.
   *     Errors:
   *         - invalid - user brand already exists or same brand exists
   *
   */
  createUserBrand: CreateUserBrandType;
  /**
   *
   *
   * **Auto Errors:**
   *
   * `invalid` - DeclineOrderError
   */
  declineSwapOrderByBuyer: DeclineSwapOrderType;
  /**
   *
   *
   * **Auto Errors:**
   *
   * `invalid` - DeclineOrderError
   */
  declineSwapOrderBySeller: DeclineSwapOrderType;
  /**
   *
   * Errors:
   *
   * - Something went wrong when decoding token - jwt token cannot be decoded.
   * - Token expired
   * - Something went wrong when creating user
   * - User deleted
   * those errors send with corresponding error codes
   *
   */
  googleAuth: GoogleAuthResponseType;
  /**
   *
   * Login by otp received from `sendLoginSmsCode`
   *
   *
   * **Auto Errors:**
   *
   * `invalid` - AuthError
   * `invalid` - PhoneVerificationError
   */
  loginByOtp: LoginByOtpType;
  /**
   * Initiates the return process for a given order.
   *
   * **Auto Errors:**
   *
   */
  orderStartReturnProcess: InitiateReturnProcessType;
  /**
   *
   * Create post errors:
   *
   * - limit exceeded (unknown) - if user used daily limit for creating
   *     post
   *
   */
  postCreate: PostCreateType;
  /**
   *
   * Delete post errors:
   *
   * - Post doesn't exist (unknown) - if u try delete post which doesn't
   *     exist
   *
   */
  postDelete: PostDeleteType;
  /**
   *
   * Add like errors:
   *
   * - Post doesn't exist (unknown) - if u try like post which doesn't
   *   exist
   *
   */
  postLike: PostLikeType;
  /**
   *
   * Remove saved post errors:
   *
   * - Post doesn't exist (unknown) - if u try remove from saved post
   *     which doesn't exist
   *
   */
  postRemoveSaved: PostRemoveSavedType;
  /**
   *
   * Saved post errors:
   *
   * - Post doesn't exist (unknown) - if u try save post which doesn't
   *   exist
   *
   */
  postSave: PostSavedType;
  /**
   *
   * Remove like errors:
   *
   * - Post doesn't exist (unknown) - if u try unlike post which doesn't
   *     exist
   *
   */
  postUnlike: PostUnlikeType;
  /**
   *
   * Refill balance. `token` or `cardId` is required
   *
   */
  refillBalance: RefillBalanceType;
  /**
   *
   *
   * **Auto Errors:**
   *
   * `invalid` - RemoveProductFromSwapError
   */
  removeProductFromSwap: RemoveProductFromSwapResultType;
  /** Adds a dialogue to be checked by a potential deal algorithm in return for an order phone number. */
  retrieveOrderPhone?: Maybe<RetrievePhoneType>;
  /** Adds a dialogue to be checked by a potential deal algorithm in return for the phone number. */
  retrieveThreadPhone?: Maybe<RetrievePhoneType>;
  /**
   *
   *     Save acquiring info
   *     Errors:
   *     - validation - Validation error
   *
   */
  saveAcquiringInfo: SaveAcquiringInfoType;
  /**
   *
   * Request to send otp verification code for card
   *
   * Errors:
   * - Forwarded from evopay client
   *
   */
  sendExternalCardsVerificationOtp: SendExternalCardsVerificationOtpInfoType;
  /**
   *
   * Send sms code for login
   *
   *
   * **Auto Errors:**
   *
   * `invalid` - AuthError
   * `invalid` - PhoneVerificationError
   * `user_does_not_exist` - User does not exist with the phone
   */
  sendLoginSmsCode: SendLoginSmsCodeType;
  /**
   * Send message from seller to subscribers if possible
   *
   * **Auto Errors:**
   *
   * `cant_send_message` - CantSendMessageError
   * `empty_message` - EmptyMessageError
   * `message_too_long` - MessageTooLongError
   * `only_for_super_and_mediocre_seller` - OnlyForMediocreAndSuperSellersError
   */
  sendMessageToSubscribers: SendMessageToSubscribersType;
  submitProductAvailabilityFeedback: SubmitProductAvailabilityFeedbackType;
  /**
   *
   * Unblock user
   *
   */
  unblockUser: BlockedUsersType;
  /**
   * Use free push on product if possible
   *
   * **Auto Errors:**
   *
   * `only_for_owner` - OnlyForOwnerError
   * `free_pushup_not_available` - FreePushupNotAvailableError
   */
  useFreePushupOnProduct: UseFreePushupType;
  /**
   *
   * Errors:
   * - Forwarded from evopay client
   *
   */
  userAddEvoCardLookup: LookupCardInfoType;
  /**
   *
   * Mark card as default in wallet
   *
   * Errors:
   * - Forwarded from evopay client
   *
   */
  userMarkEvoCardAsDefault: MarkEvoCardAsDefaultInfoType;
  /**
   *
   * Remove card from wallet
   *
   * Errors:
   * Forwarded from evopay client:
   * -
   *
   */
  userRemoveEvoCard: RemoveEvoCardInfoType;
  /**
   *
   * Verify otp code for external card
   *
   * Errors:
   * - Forwarded from evopay client
   *
   */
  verifyExternalCardsOtp: VerifyExternalCardsOtpInfoType;
};


export type MutationAddProductToSwapArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationApproveSwapOrderArgs = {
  orderId: Scalars['Int']['input'];
  sellerWarehouseId: Scalars['String']['input'];
  userInfo: SwapOrderSellerInfoType;
};


export type MutationBlockUserArgs = {
  blockedUserId: Scalars['String']['input'];
};


export type MutationChangeReceivingPaymentMethodArgs = {
  method: ReceivingPaymentMethod;
};


export type MutationChangeShowPhoneNumberArgs = {
  showPhoneNumber: Scalars['Boolean']['input'];
};


export type MutationCommentCreateArgs = {
  body: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};


export type MutationCommentDeleteArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationCommentLikeArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationCommentUnlikeArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationCreateOrderPurchaseArgs = {
  applePayToken?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<PaymentFingerprint>;
  googlePayToken?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSwapOrderArgs = {
  deliveryService: DeliveryService;
  items: Array<SwapOrderItemInput>;
  userInfo: SwapOrderUserInfoType;
  warehouseId: Scalars['String']['input'];
};


export type MutationCreateUserBrandArgs = {
  title: Scalars['String']['input'];
};


export type MutationDeclineSwapOrderByBuyerArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationDeclineSwapOrderBySellerArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationGoogleAuthArgs = {
  token: Scalars['String']['input'];
};


export type MutationLoginByOtpArgs = {
  otp: Scalars['String']['input'];
  phoneNumber: Scalars['PhoneNumber']['input'];
  pow: PowType;
  userInfo?: InputMaybe<UserInfoType>;
};


export type MutationOrderStartReturnProcessArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationPostCreateArgs = {
  description: Scalars['String']['input'];
  kind: PostKind;
  mediasUrls: Array<Scalars['String']['input']>;
  productsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationPostDeleteArgs = {
  postId: Scalars['String']['input'];
};


export type MutationPostLikeArgs = {
  postId: Scalars['String']['input'];
};


export type MutationPostRemoveSavedArgs = {
  postId: Scalars['String']['input'];
};


export type MutationPostSaveArgs = {
  postId: Scalars['String']['input'];
};


export type MutationPostUnlikeArgs = {
  postId: Scalars['String']['input'];
};


export type MutationRefillBalanceArgs = {
  amount: Scalars['String']['input'];
  applePayToken?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<PaymentFingerprint>;
  googlePayToken?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  resultUrlPayload?: InputMaybe<Array<ResultUrlPayloadType>>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveProductFromSwapArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationRetrieveOrderPhoneArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationRetrieveThreadPhoneArgs = {
  threadId: Scalars['Int']['input'];
};


export type MutationSaveAcquiringInfoArgs = {
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationSendExternalCardsVerificationOtpArgs = {
  projectId: Scalars['String']['input'];
  resendSms?: Scalars['Boolean']['input'];
};


export type MutationSendLoginSmsCodeArgs = {
  phoneNumber: Scalars['PhoneNumber']['input'];
  pow: PowType;
};


export type MutationSendMessageToSubscribersArgs = {
  message: Scalars['String']['input'];
};


export type MutationSubmitProductAvailabilityFeedbackArgs = {
  answer: ProductAvailabilityFeedbackAnswer;
  feedbackId: Scalars['ID']['input'];
};


export type MutationUnblockUserArgs = {
  blockedUserId: Scalars['String']['input'];
};


export type MutationUseFreePushupOnProductArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationUserAddEvoCardLookupArgs = {
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationUserMarkEvoCardAsDefaultArgs = {
  id: Scalars['String']['input'];
};


export type MutationUserRemoveEvoCardArgs = {
  cardId: Scalars['String']['input'];
};


export type MutationVerifyExternalCardsOtpArgs = {
  code: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type NamespaceType = {
  __typename?: 'NamespaceType';
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Namespace id in database */
  value: Scalars['Int']['output'];
};

export type NearestWarehouseDataType = {
  __typename?: 'NearestWarehouseDataType';
  text?: Maybe<Scalars['String']['output']>;
  warehouseInfo?: Maybe<DeliveryInfoType>;
};

export type NotificationButtonType = {
  __typename?: 'NotificationButtonType';
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NotificationType = {
  __typename?: 'NotificationType';
  button: NotificationButtonType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  templateId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OrderDeliveryInfoType = {
  __typename?: 'OrderDeliveryInfoType';
  deliveryService: DeliveryService;
  description: Scalars['String']['output'];
  icon: Scalars['StaticUrlType']['output'];
  name: Scalars['String']['output'];
};

export type OrderSummaryDetailType = {
  __typename?: 'OrderSummaryDetailType';
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderSummaryType = {
  __typename?: 'OrderSummaryType';
  details: Array<OrderSummaryDetailType>;
  total: Scalars['String']['output'];
};

export type OrderType = {
  __typename?: 'OrderType';
  canViewPhone: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
  viewPhoneText?: Maybe<Scalars['String']['output']>;
};

/** Information to aid in pagination. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaymentFingerprint = {
  browserAcceptHeader: Scalars['String']['input'];
  browserColorDepth: Scalars['String']['input'];
  browserJavaEnabled: Scalars['String']['input'];
  browserLanguage: Scalars['String']['input'];
  browserScreenHeight: Scalars['String']['input'];
  browserScreenWidth: Scalars['String']['input'];
  browserTimeZone: Scalars['String']['input'];
  browserTimeZoneOffset: Scalars['String']['input'];
  browserUserAgent: Scalars['String']['input'];
};

export type PaymentMethodType = {
  __typename?: 'PaymentMethodType';
  description: Scalars['String']['output'];
  descriptionIfHidden: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: PaymentType;
  isEnabled: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum PaymentTerminal {
  Acquiring = 'acquiring',
  Delivery = 'delivery',
  Order = 'order',
  Site = 'site',
  Subscription = 'subscription'
}

export type PaymentTransactionType = {
  __typename?: 'PaymentTransactionType';
  /** Balance after transaction */
  balance: Scalars['Decimal']['output'];
  /** Bonus balance after transaction */
  bonusBalance: Scalars['Decimal']['output'];
  /** Transaction buyer */
  buyer?: Maybe<User>;
  /** Transaction creation datetime */
  createdAt: Scalars['String']['output'];
  /** Transaction description */
  description: Scalars['String']['output'];
  /** Transaction full amount */
  fullAmount: Scalars['String']['output'];
  /** Id of payment transaction */
  id: Scalars['String']['output'];
  /** Transaction product */
  product?: Maybe<ProductType>;
  /** Thread Id where user bought product */
  threadId?: Maybe<Scalars['Int']['output']>;
  /** Transaction type */
  type?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type PaymentTransactionTypeConnection = {
  __typename?: 'PaymentTransactionTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<PaymentTransactionTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PaymentTransactionTypeEdge = {
  __typename?: 'PaymentTransactionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PaymentTransactionType;
};

export enum PaymentType {
  PayLater = 'PAY_LATER',
  SafePayment = 'SAFE_PAYMENT',
  SellerCard = 'SELLER_CARD'
}

export type PopUpItemType = {
  __typename?: 'PopUpItemType';
  icon: Scalars['String']['output'];
  markListItems?: Maybe<Array<Scalars['String']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PopupInfoType = {
  __typename?: 'PopupInfoType';
  removeText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PosNegValue = {
  __typename?: 'PosNegValue';
  negative: Scalars['Int']['output'];
  positive: Scalars['Int']['output'];
};

export type PostCreateType = {
  __typename?: 'PostCreateType';
  errors?: Maybe<Array<GraphResponseError>>;
  post?: Maybe<PostType>;
};

export type PostDeleteType = {
  __typename?: 'PostDeleteType';
  errors?: Maybe<Array<GraphResponseError>>;
};

export enum PostKind {
  Photo = 'PHOTO',
  Video = 'VIDEO'
}

export type PostLikeType = {
  __typename?: 'PostLikeType';
  errors?: Maybe<Array<GraphResponseError>>;
  post?: Maybe<PostType>;
};

export type PostRemoveSavedType = {
  __typename?: 'PostRemoveSavedType';
  errors?: Maybe<Array<GraphResponseError>>;
  post?: Maybe<PostType>;
};

export type PostSavedType = {
  __typename?: 'PostSavedType';
  errors?: Maybe<Array<GraphResponseError>>;
  post?: Maybe<PostType>;
};

export enum PostSource {
  Review = 'REVIEW',
  User = 'USER'
}

export enum PostStatus {
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  Moderated = 'MODERATED',
  Published = 'PUBLISHED'
}

/** Information about the user's post. */
export type PostType = {
  __typename?: 'PostType';
  /**
   *
   * Return UserType for post's author
   *
   */
  author: User;
  /** author id of the current post. */
  authorId: Scalars['String']['output'];
  /**
   *
   * Paginated list of comments for some particular post.
   *
   */
  comments: CommentTypeConnectionProxy;
  /** count of comments for the current post. */
  commentsCount: Scalars['Int']['output'];
  /** The date of the creating current post. */
  createdAt: Scalars['DateTime']['output'];
  /** The reason for declined of the current post. */
  declinedReason?: Maybe<Scalars['String']['output']>;
  /** The main text body for the post. */
  description: Scalars['String']['output'];
  /** id of the current post. */
  id: Scalars['String']['output'];
  /** True if current user liked this post. */
  isLiked: Scalars['Boolean']['output'];
  /** True if current user saved this post. */
  isSaved: Scalars['Boolean']['output'];
  /** count of likes for the current post. */
  likesCount: Scalars['Int']['output'];
  /** The list of media files related to this post. */
  mediasUrls: Array<Scalars['String']['output']>;
  /**
   *
   * Return paginated list of posts which similar to the received post.
   *
   * For pagination we use seek approach, so u can't use reverse
   * pagination. hasPrevPage always is False.
   *
   */
  postsSimilar: PostTypeConnectionProxy;
  /**
   *
   * Return list of ProductType related to current post.
   *
   * Note:
   *
   *     max count - 5 items
   *
   */
  products: Array<ProductType>;
  /** The list of product ids related to this post. */
  productsIds: Array<Scalars['String']['output']>;
  /** count of saved for the current post. */
  savedCount: Scalars['Int']['output'];
  /** From the source of current post. */
  source: PostSource;
  /** The status of the current post. */
  status: PostStatus;
  /** The list of short tags: #women, #2023. */
  tags: Array<Scalars['String']['output']>;
  /** Post type. */
  type: PostKind;
  /**
   *
   * Return the URL for the current post.
   *
   */
  url: Scalars['String']['output'];
  /** Estimated number of views of the current post. (not real time data) */
  viewsCount: Scalars['Int']['output'];
};


/** Information about the user's post. */
export type PostTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Information about the user's post. */
export type PostTypePostsSimilarArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Information about the user's post. */
export type PostTypeProductsArgs = {
  activeOnly?: Scalars['Boolean']['input'];
};

/** A connection to a list of items. */
export type PostTypeConnectionProxy = {
  __typename?: 'PostTypeConnectionProxy';
  /** Contains the nodes in this connection */
  edges: Array<PostTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PostTypeEdge = {
  __typename?: 'PostTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PostType;
};

export type PostUnlikeType = {
  __typename?: 'PostUnlikeType';
  errors?: Maybe<Array<GraphResponseError>>;
  post?: Maybe<PostType>;
};

/** The source of the post view (for which block or page this item is used). */
export enum PostViewSource {
  /** Use this source for a detailed view of the post. With this source, we will calculate the views count. */
  Detailed = 'DETAILED'
}

export type PowType = {
  /** The solution that was generated by the user, using the data from the COMPLEXITY and PREFIX fields */
  nonce: Scalars['String']['input'];
  /** Data from `powInfo` query */
  prefix: Scalars['String']['input'];
};

export type PriceFilterType = {
  __typename?: 'PriceFilterType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priceFrom?: Maybe<Scalars['Int']['output']>;
  priceTo?: Maybe<Scalars['Int']['output']>;
};

export type PriceRangeType = {
  __typename?: 'PriceRangeType';
  /** Deviation from median price in % */
  deviation: Scalars['Int']['output'];
  high: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
  median: Scalars['Int']['output'];
};

export type ProductAlsoSearchCatalogLinkType = {
  __typename?: 'ProductAlsoSearchCatalogLinkType';
  catalogNamespace: Scalars['String']['output'];
  catalogSlug: Scalars['String']['output'];
  citySlug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ProductAlsoSearchCatalogLinkTypeProductAlsoSearchVirtualCatalogLinkTypeProductAlsoSearchTagLinkType = ProductAlsoSearchCatalogLinkType | ProductAlsoSearchTagLinkType | ProductAlsoSearchVirtualCatalogLinkType;

export type ProductAlsoSearchTagLinkType = {
  __typename?: 'ProductAlsoSearchTagLinkType';
  tagSlug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProductAlsoSearchVirtualCatalogLinkType = {
  __typename?: 'ProductAlsoSearchVirtualCatalogLinkType';
  title: Scalars['String']['output'];
  virtualCatalogSlug: Scalars['String']['output'];
};

export enum ProductAvailabilityFeedbackAnswer {
  Ignored = 'IGNORED',
  No = 'NO',
  Yes = 'YES'
}

export type ProductAvailabilityFeedbackType = {
  __typename?: 'ProductAvailabilityFeedbackType';
  id: Scalars['ID']['output'];
  product: ProductType;
};

export type ProductCharacteristicChoiceType = {
  __typename?: 'ProductCharacteristicChoiceType';
  characteristic: ProductCharacteristicType;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isIndexed: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};


export type ProductCharacteristicChoiceTypeIsIndexedArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCharacteristicType = {
  __typename?: 'ProductCharacteristicType';
  choices: Array<ProductCharacteristicChoiceType>;
  description?: Maybe<Scalars['String']['output']>;
  excludeFromCompletionScale: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRequired: Scalars['Boolean']['output'];
  maxCountForSelect: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export enum ProductExpirationStatusType {
  /** If product is expired with this type, it means that client should get 410 http status code and see according page that product or page does not exist anymore. This is important for SEO. */
  Expired_410 = 'EXPIRED_410',
  /** If product is expired with this type, it means non owner client should be redirected to product's catalog page. With notification that product is not available anymore. */
  ExpiredRedirectCatalog = 'EXPIRED_REDIRECT_CATALOG'
}

export type ProductReviewType = {
  __typename?: 'ProductReviewType';
  buyer: User;
  id: Scalars['ID']['output'];
  overallRating: Scalars['Float']['output'];
  product?: Maybe<ProductType>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** This type represent information about product. */
export type ProductType = {
  __typename?: 'ProductType';
  alsoSearchLinks: Array<ProductAlsoSearchCatalogLinkTypeProductAlsoSearchVirtualCatalogLinkTypeProductAlsoSearchTagLinkType>;
  /** Bonusback info for display */
  bonusbackInfo?: Maybe<BonusbackInfoType>;
  /** The information about product's brand */
  brand?: Maybe<BrandType>;
  /** id of the product's brand */
  brandId?: Maybe<Scalars['Int']['output']>;
  catalog: CatalogType;
  /** id of the product's catalog */
  catalogId: Scalars['Int']['output'];
  /** Explains expiration status for product. See enum values description to understand how to properly handle each status. */
  expirationStatus?: Maybe<ProductExpirationStatusType>;
  /** The internal product id. */
  id: Scalars['Int']['output'];
  /** Meta description is used in <meta name="description" /> tag */
  metaDescription: Scalars['String']['output'];
  /** Meta title is used in <title> tag */
  metaTitle: Scalars['String']['output'];
  /** The `name` of current product. */
  name: Scalars['String']['output'];
  owner: User;
  /** The price of thу current product on UAH. */
  price: Scalars['Float']['output'];
  /** price range for similar products */
  priceRange?: Maybe<PriceRangeType>;
  /** Need sort by order by */
  priceVariants: Array<ProductVariantType>;
  /** The average rating of the current product. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** The amount of ratings for the current product. */
  ratingAmount?: Maybe<Scalars['Int']['output']>;
  /** Returns a size chart sorted by size sorting field */
  sizeCharts: Array<SizeChartsType>;
  /** The `slug` of current product which need to use for build url. */
  slug: Scalars['String']['output'];
  /** The visibility status of current product. */
  statusTitle?: Maybe<ProductVisibleStatusType>;
  /** The list of tags for product */
  tags: Array<Scalars['String']['output']>;
  /** The url to main image of current product. This image is small and we can use it for show preview. */
  thumbnail: Scalars['String']['output'];
  /** Link to the current product on the website. */
  url: Scalars['String']['output'];
  /** The user status of current product. */
  userStatusTitle: ProductUserStatusType;
};

export enum ProductUserStatusType {
  Default = 'DEFAULT',
  Hidden = 'HIDDEN'
}

export type ProductVariantType = {
  __typename?: 'ProductVariantType';
  id: Scalars['ID']['output'];
  /** Price of the variant */
  price: Scalars['Int']['output'];
  size: SizeType;
};

export enum ProductViewSource {
  Catalog = 'catalog',
  Collection = 'collection'
}

export enum ProductVisibleStatusType {
  Available = 'AVAILABLE',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  ModerationRequired = 'MODERATION_REQUIRED',
  Reserved = 'RESERVED',
  Sold = 'SOLD'
}

export type Query = {
  __typename?: 'Query';
  /** product form guidelines */
  adGuidelines: Array<AdGuidelinesType>;
  advantagesForTopSeller: Array<TopSellerProsType>;
  /** data for create payments through app pay */
  appPayInfo: AppPayInfoType;
  bestSellersInCategory: BestSellersInCategoryType;
  /** Information for brands feed page */
  brandFeedInfo: BrandFeedInfoType;
  /** Swap order information displayed on buyer checkout */
  buyerSwapOrderSummary: OrderSummaryType;
  /** If slug does not provide it, will return root catalogs */
  catalog: CatalogType;
  catalogBuyerPositiveReviews: Array<ProductReviewType>;
  chatBotMeta?: Maybe<ChatBotMetaType>;
  /** Get info for decline order popup */
  declineSwapOrderBySellerInfo: DeclineSwapOrderBySellerInfoType;
  evoCardAddForm: Scalars['String']['output'];
  /** Get widget key for mobile SDK */
  evoPayWidgetKey: Scalars['String']['output'];
  /** Return a selection of characteristics based on the description and title */
  extractCharacteristics: Array<ProductCharacteristicChoiceType>;
  filterBrands: Array<BrandType>;
  filterColors: Array<ColorFilterType>;
  filterConditions: Array<ConditionFilterType>;
  filterPrices: Array<PriceFilterType>;
  filterSizes: Array<SizeFilterType>;
  filterThematics: ThematicFiltersType;
  filterTopBrands: TopBrandFilterType;
  /** Get nearest rozetka warehouse in city of chosen warehouse */
  getNearestRozetkaWarehouse: NearestWarehouseDataType;
  /** Check whether evo card with card_id is confirmed */
  isEvoCardConfirmed: IsCardConfirmedInfoType;
  /** Return current logo. */
  logo: LogoImageType;
  /** Return information related to banner on the main page. */
  mainBanner: MainBannerType;
  /**
   *
   * The same as viewer.
   *
   * Now we have problem with apollo cache for frontend client. For
   * correct work we need to return the same type for some specific
   * field each time. Now for viewer we return the ViewerType and the
   * UserType. So, to avoid this problem we've created separate field
   * `me` which duplicated viewer.
   *
   */
  me?: Maybe<ViewerType>;
  /** User notification */
  notification?: Maybe<NotificationType>;
  /** Fetch brands for showing on onboarding screen. */
  onBoardingBrands: Array<BrandType>;
  /** Fetch catalogs for showing on onboarding screen. */
  onBoardingCatalogs: Scalars['JSON']['output'];
  order?: Maybe<OrderType>;
  /** Return post by id if exists. */
  post?: Maybe<PostType>;
  /**
   *
   * Return paginated list of posts which related to the received
   * product.
   *
   * For pagination we use seek approach, so u can't use reverse
   * pagination. hasPrevPage always is False.
   *
   */
  postsByProduct: PostTypeConnectionProxy;
  /**
   *
   * Return paginated list of posts for the general page.
   *
   * For pagination we use seek approach, so u can't use reverse
   * pagination. hasPrevPage always is False.
   *
   */
  postsForGeneral: PostTypeConnectionProxy;
  /** The information about product with received id. */
  product?: Maybe<ProductType>;
  /** Get prediction of commission percent (range) for given product price. */
  productCommissionPercentPredict: Scalars['String']['output'];
  /** Fetch brands for showing on product form */
  productFormBrands: Array<BrandTypeUserBrandType>;
  productsAvailabilityFeedbacks: Array<ProductAvailabilityFeedbackType>;
  /** Return recommended categories by text */
  recommendedCategories: Array<CatalogType>;
  /** Get info for remove from SWAP popup */
  removeFromSwapInfoForProduct: RemoveProductFromSwapInfoType;
  /** Get search suggestions */
  searchSuggestions: Array<SearchSuggestType>;
  /** Swap order information displayed on seller checkout */
  sellerSwapOrderSummary: OrderSummaryType;
  /** The seo hub for the catalog. */
  seoHubByCatalog: Array<SeoHubBlockType>;
  /** The seo hub for the seo tag. */
  seoHubBySeoTag: Array<SeoHubBlockType>;
  seoTag: SeoTagType;
  settings: GlobalSettingsType;
  /**
   *
   *         Get catalogues by searching for a text. If a catalogue slug is provided,
   *         it will only return catalogues for that catalogue.
   *         If a dynamic collection slug is provided, it will
   *         only return results for that collection.
   */
  suggestCatalogs: Array<CatalogType>;
  swapCommission: Scalars['String']['output'];
  swapOrder?: Maybe<SwapOrderType>;
  /** Notifications that users should update their settings */
  updateNotifications: Array<UpdateNotificationType>;
  user?: Maybe<User>;
  /**
   *
   * The information related to the current auth user.
   *
   */
  viewer?: Maybe<ViewerType>;
};


export type QueryAdGuidelinesArgs = {
  catalogSlug?: Scalars['String']['input'];
  guidelinesType: AdGuidelinesChoice;
};


export type QueryBestSellersInCategoryArgs = {
  catalogSlug: Scalars['String']['input'];
  onboarding: Scalars['Boolean']['input'];
};


export type QueryCatalogArgs = {
  slug?: Scalars['String']['input'];
};


export type QueryCatalogBuyerPositiveReviewsArgs = {
  catalogSlug: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};


export type QueryEvoCardAddFormArgs = {
  height: Scalars['String']['input'];
};


export type QueryExtractCharacteristicsArgs = {
  catalogSlug: Scalars['String']['input'];
  productDescription: Scalars['String']['input'];
  productDescriptionUk?: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  productNameUk?: Scalars['String']['input'];
};


export type QueryFilterBrandsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first: Scalars['Int']['input'];
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilterSizesArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  sizeGroup?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFilterThematicsArgs = {
  catalogSlug?: Scalars['String']['input'];
};


export type QueryFilterTopBrandsArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  dynamicCollectionSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNearestRozetkaWarehouseArgs = {
  deliveryService: DeliveryService;
  forceSubscription?: Scalars['Boolean']['input'];
  productsId: Array<Scalars['Int']['input']>;
  sellerId: Scalars['Int']['input'];
  warehouseDocId: Scalars['String']['input'];
  withoutDistance?: Scalars['Boolean']['input'];
};


export type QueryIsEvoCardConfirmedArgs = {
  cardId: Scalars['String']['input'];
};


export type QueryMainBannerArgs = {
  forMobileApps?: InputMaybe<Scalars['Boolean']['input']>;
  forThankYouPage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNotificationArgs = {
  notificationId: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryPostArgs = {
  postId: Scalars['String']['input'];
  sourceView?: InputMaybe<PostViewSource>;
};


export type QueryPostsByProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
};


export type QueryPostsForGeneralArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductArgs = {
  fromAdv?: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  incrViews?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<ProductViewSource>;
};


export type QueryProductCommissionPercentPredictArgs = {
  productPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryProductFormBrandsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first: Scalars['Int']['input'];
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  searchStr?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecommendedCategoriesArgs = {
  searchText: Scalars['String']['input'];
};


export type QueryRemoveFromSwapInfoForProductArgs = {
  productId: Scalars['Int']['input'];
};


export type QuerySearchSuggestionsArgs = {
  catalogSlug?: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  searchText: Scalars['String']['input'];
};


export type QuerySeoHubByCatalogArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySeoHubBySeoTagArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySeoTagArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySuggestCatalogsArgs = {
  catalogSlug?: Scalars['String']['input'];
  dynamicCollectionSlug?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  searchText: Scalars['String']['input'];
};


export type QuerySwapOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryUserArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type RatingValue = {
  __typename?: 'RatingValue';
  value: Scalars['String']['output'];
};

export type RatingValueTextValuePosNegValue = PosNegValue | RatingValue | TextValue;

export enum ReceivingPaymentMethod {
  Acquiring = 'acquiring',
  Card = 'card'
}

export type RefillBalanceType = {
  __typename?: 'RefillBalanceType';
  confirmationUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<GraphResponseError>>;
  paymentId?: Maybe<Scalars['String']['output']>;
};

export type RelinkingCatalogType = {
  __typename?: 'RelinkingCatalogType';
  /** Catalog URL */
  slug: Scalars['String']['output'];
  /** Catalog title */
  title: Scalars['String']['output'];
};

export type RelinkingIndexedFilterType = {
  __typename?: 'RelinkingIndexedFilterType';
  catalogSlug: Scalars['String']['output'];
  /** Indexed filter ID */
  indexedFilterEntityId: Scalars['String']['output'];
  /** Type of indexed filter */
  indexedFilterType: IndexedFilterTypeEnum;
  title: Scalars['String']['output'];
};

export type RelinkingLinkUnion = RelinkingCatalogType | RelinkingIndexedFilterType | RelinkingSeoTagType;

export type RelinkingSeoTagType = {
  __typename?: 'RelinkingSeoTagType';
  /** Tag slug */
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RemoveEvoCardInfoType = {
  __typename?: 'RemoveEvoCardInfoType';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type RemoveProductFromSwapInfoType = {
  __typename?: 'RemoveProductFromSwapInfoType';
  errors?: Maybe<Array<GraphResponseError>>;
  isRemoveAvailable: Scalars['Boolean']['output'];
  popupInfo?: Maybe<PopupInfoType>;
};

export type RemoveProductFromSwapResultType = {
  __typename?: 'RemoveProductFromSwapResultType';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type ResultUrlPayloadType = {
  name: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

export type RetrievePhoneType = {
  __typename?: 'RetrievePhoneType';
  phoneNumber: Scalars['String']['output'];
};

export type SaveAcquiringInfoType = {
  __typename?: 'SaveAcquiringInfoType';
  errors?: Maybe<Array<GraphResponseError>>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Wrapper for saved post. */
export type SavedPostType = {
  __typename?: 'SavedPostType';
  /** id which u need to use for pagination */
  id: Scalars['String']['output'];
  /** The saved post. */
  post: PostType;
};

/** A connection to a list of items. */
export type SavedPostTypeConnectionProxy = {
  __typename?: 'SavedPostTypeConnectionProxy';
  /** Contains the nodes in this connection */
  edges: Array<SavedPostTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SavedPostTypeEdge = {
  __typename?: 'SavedPostTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SavedPostType;
};

export type SearchSuggestType = {
  __typename?: 'SearchSuggestType';
  id: Scalars['ID']['output'];
  /** return replacement for search suggest */
  replacementOfSuggest?: Maybe<SuggestReplacementType>;
  search: Scalars['String']['output'];
};

export type SellerRatingInfoBlockType = {
  __typename?: 'SellerRatingInfoBlockType';
  items: Array<SellerRatingItemType>;
};

export type SellerRatingInfoType = {
  __typename?: 'SellerRatingInfoType';
  blocks: Array<SellerRatingInfoBlockType>;
  overallRating: Scalars['String']['output'];
  reviewsCount: Scalars['Int']['output'];
  reviewsCountByPeriod: Scalars['Int']['output'];
};

export type SellerRatingItemType = {
  __typename?: 'SellerRatingItemType';
  title: Scalars['String']['output'];
  value?: Maybe<RatingValueTextValuePosNegValue>;
};

export enum SellersBoostType {
  BadSeller = 'BAD_SELLER',
  MediocreSeller = 'MEDIOCRE_SELLER',
  Newcamer = 'NEWCAMER',
  None = 'NONE',
  TopSeller = 'TOP_SELLER'
}

/** Response after attempt to send an otp code */
export type SendExternalCardsVerificationOtpInfoType = {
  __typename?: 'SendExternalCardsVerificationOTPInfoType';
  errors?: Maybe<Array<GraphResponseError>>;
  /** The date when the verification code will expire. Time in UTC */
  expiresAt: Scalars['String']['output'];
  /** The phone number to which the verification code was sent. */
  phone: Scalars['String']['output'];
};

export type SendLoginSmsCodeType = {
  __typename?: 'SendLoginSmsCodeType';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type SendMessageToSubscribersType = {
  __typename?: 'SendMessageToSubscribersType';
  errors?: Maybe<Array<GraphResponseError>>;
  nextTimeCanSendAt?: Maybe<Scalars['Date']['output']>;
};

/** The container for common information related to the seo hub block. */
export type SeoHubBlockType = {
  __typename?: 'SeoHubBlockType';
  /** The type of the seo hub block. */
  blockType: SeoHubBlockTypeEnum;
  /** Inner items for the current block. */
  items: Array<SeoHubItemType>;
  /** The title of the seo hub block. */
  title: Scalars['String']['output'];
};

/** Type of the seo hub block. */
export enum SeoHubBlockTypeEnum {
  Brands = 'BRANDS',
  FirstCustomBlock = 'FIRST_CUSTOM_BLOCK',
  PopularCategories = 'POPULAR_CATEGORIES',
  SecondCustomBlock = 'SECOND_CUSTOM_BLOCK'
}

/** The info about seo hub item. */
export type SeoHubItemType = {
  __typename?: 'SeoHubItemType';
  /** The url to the product image. */
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** The item's *title* */
  title: Scalars['String']['output'];
  /** the url to the item catalog/seo-tag */
  url: Scalars['String']['output'];
};

/** Tag information with all related data */
export type SeoTagType = {
  __typename?: 'SeoTagType';
  bottomCrosslinking: Array<RelinkingLinkUnion>;
  /** List of parent catalogs for breadcrumb navigation */
  breadcrumbs: Array<CatalogType>;
  catalog: CatalogType;
  city?: Maybe<CityType>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  redirectTo?: Maybe<Scalars['String']['output']>;
  /** Explicitly defined SEO description. If None, client must generate default description on its side. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoMetaDescription: Scalars['String']['output'];
  seoMetaTitle: Scalars['String']['output'];
  similarTags: Array<SimilarSeoTagType>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SimilarSeoTagType = {
  __typename?: 'SimilarSeoTagType';
  /** Tag ID */
  id: Scalars['ID']['output'];
  /** Tag URL slug */
  slug: Scalars['String']['output'];
  /** Tag title */
  title: Scalars['String']['output'];
};

export type SizeChartsType = {
  __typename?: 'SizeChartsType';
  size: SizeType;
  /** Missing entries are handled gracefully. Sorted by title */
  values: Array<SizeChartsValueType>;
};

export type SizeChartsValueType = {
  __typename?: 'SizeChartsValueType';
  groupId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type SizeFilterType = {
  __typename?: 'SizeFilterType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  primarySizeName: Scalars['String']['output'];
  secondarySizeName?: Maybe<Scalars['String']['output']>;
};

export type SizeGroupType = {
  __typename?: 'SizeGroupType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SizeType = {
  __typename?: 'SizeType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderBy: Scalars['Int']['output'];
};

/** Image data */
export type SlideImageType = {
  __typename?: 'SlideImageType';
  /** The url to the slide image suited for mobile devices */
  mobile: Scalars['String']['output'];
  /** The url to the slide image for tablet or desktop screen sizes */
  tablet: Scalars['String']['output'];
};

export type SubmitProductAvailabilityFeedbackType = {
  __typename?: 'SubmitProductAvailabilityFeedbackType';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type SuggestReplacementType = {
  __typename?: 'SuggestReplacementType';
  /** Slug of seo tag */
  slug: Scalars['String']['output'];
};

export type SwapOrderItemInput = {
  productId: Scalars['ID']['input'];
  sizeId?: InputMaybe<Scalars['ID']['input']>;
};

export type SwapOrderItemType = {
  __typename?: 'SwapOrderItemType';
  product: ProductType;
  /** Selected size */
  size?: Maybe<SizeType>;
};

export type SwapOrderSellerInfoType = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
};

export type SwapOrderType = {
  __typename?: 'SwapOrderType';
  buyer: User;
  canBeApproved: Scalars['Boolean']['output'];
  canBeDeclinedBuyer: Scalars['Boolean']['output'];
  delivery: OrderDeliveryInfoType;
  id: Scalars['ID']['output'];
  items: Array<SwapOrderItemType>;
  seller: User;
  threadId: Scalars['ID']['output'];
};

export type SwapOrderUserInfoType = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  phoneNumber: Scalars['PhoneNumber']['input'];
};

export type TextValue = {
  __typename?: 'TextValue';
  img: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ThematicBrandFilterType = ThematicFilterType & {
  __typename?: 'ThematicBrandFilterType';
  brand: BrandType;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ThematicColorFilterType = ThematicFilterType & {
  __typename?: 'ThematicColorFilterType';
  color: ColorFilterType;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ThematicFilterType = {
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ThematicFiltersType = {
  __typename?: 'ThematicFiltersType';
  brands: Array<ThematicBrandFilterType>;
  characteristics: Array<CatalogCharacteristicFilterType>;
  colors: Array<ThematicColorFilterType>;
};

export type TopBrandFilterType = {
  __typename?: 'TopBrandFilterType';
  brands: Array<BrandType>;
  topBrands: Array<BrandType>;
};

export type TopSellerIndicatorType = {
  __typename?: 'TopSellerIndicatorType';
  /** Value is between 0 and 100 or float */
  currentValue: Scalars['String']['output'];
  /** Value is between 0 and 100 or float */
  goal: Scalars['String']['output'];
  /** how much of the goal was achieved */
  progress: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TopSellerProsType = {
  __typename?: 'TopSellerProsType';
  image: Scalars['String']['output'];
  /** Text with html tags */
  title: Scalars['String']['output'];
};

export enum TransactionFilterType {
  All = 'ALL',
  Balance = 'BALANCE',
  Bonus = 'BONUS'
}

export enum TypeOfWarehouse {
  Postomate = 'POSTOMATE',
  PostOffice = 'POST_OFFICE'
}

export enum UpdateNotificationAction {
  AccountType = 'ACCOUNT_TYPE',
  AllSettings = 'ALL_SETTINGS',
  DeliverySettings = 'DELIVERY_SETTINGS',
  PaymentSettings = 'PAYMENT_SETTINGS',
  ReturnSettings = 'RETURN_SETTINGS'
}

export type UpdateNotificationType = {
  __typename?: 'UpdateNotificationType';
  /** the page to which the user should be directed */
  action: UpdateNotificationAction;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type UseFreePushupType = {
  __typename?: 'UseFreePushupType';
  errors?: Maybe<Array<GraphResponseError>>;
  freePushupsLeft?: Maybe<Scalars['Int']['output']>;
  nextFreePushupAt?: Maybe<Scalars['Date']['output']>;
};

export type User = {
  __typename?: 'User';
  acquiringData?: Maybe<AcquiringDataType>;
  /** url with avatar for current user */
  avatar: Scalars['String']['output'];
  ban?: Maybe<UserBanInfoType>;
  canUseFreePush: Scalars['Boolean']['output'];
  enrolmentCard?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** The number of followers for current user */
  followersCount: Scalars['Int']['output'];
  freePushupsLeft: Scalars['Int']['output'];
  freePushupsLimit: Scalars['Int']['output'];
  /** internal id for current user */
  id: Scalars['Int']['output'];
  isSeller: Scalars['Boolean']['output'];
  /** return True if viewer followed current user */
  isSubscribed: Scalars['Boolean']['output'];
  isTopSeller: Scalars['Boolean']['output'];
  /** whether a user is subject to any restrictions */
  isUserRestrictedByBankId: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  patronymic?: Maybe<Scalars['String']['output']>;
  /** settings of payments methods */
  paymentMethods: Array<PaymentMethodType>;
  /**
   *
   * Return paginated list of posts for particular user.
   *
   * For pagination we use seek approach, so u can't use reverse
   * pagination. hasPrevPage always is False.
   *
   */
  posts: PostTypeConnectionProxy;
  /**
   *
   * Return the number of posts created by the current user which are
   * available to the viewer.
   *
   * Note:
   *     user(id: 1) { posts ... } - return only posts which are
   *     available to the viewer
   *
   */
  postsAmount: Scalars['Int']['output'];
  /** represent the prepayment amount associated with order payment */
  prepayment: Scalars['String']['output'];
  sellerRatingInfo?: Maybe<SellerRatingInfoType>;
  sendMessageToSubscribersAccess: Scalars['Boolean']['output'];
  /** shop name for current user (not unique) */
  shopName?: Maybe<Scalars['String']['output']>;
  /** Delivery services available for use with swap order */
  swapDeliveryServices: Array<DeliveryServiceDetailType>;
  url: Scalars['String']['output'];
  /** unique username for current user */
  username: Scalars['String']['output'];
};


export type UserPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type UserBanInfoType = {
  __typename?: 'UserBanInfoType';
  isActive: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  reasonType: UserBanReasonType;
  validFrom: Scalars['Date']['output'];
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export enum UserBanReasonType {
  TypeFraud = 'TYPE_FRAUD',
  TypeOther = 'TYPE_OTHER'
}

export enum UserBlockedBy {
  BlockedByAdmin = 'BLOCKED_BY_ADMIN',
  BlockedBySystem = 'BLOCKED_BY_SYSTEM',
  NotBlocked = 'NOT_BLOCKED'
}

export type UserBrandType = {
  __typename?: 'UserBrandType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  onModeration: Scalars['Boolean']['output'];
};

export type UserInfoType = {
  /** Client id. Web only */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** User fingerprint. Valid JSON string */
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  /** Unique phone id. App only */
  phoneId?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyExternalCardsOtpInfoType = {
  __typename?: 'VerifyExternalCardsOTPInfoType';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type ViewerType = {
  __typename?: 'ViewerType';
  /** Acquiring information */
  acquiring: AcquiringType;
  acquiringData?: Maybe<AcquiringDataType>;
  /** url with avatar for current user */
  avatar: Scalars['String']['output'];
  ban?: Maybe<UserBanInfoType>;
  /** user block status */
  blockedBy: UserBlockedBy;
  blockedUserIds: Array<Scalars['Int']['output']>;
  canUseFreePush: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** If true, UI should provide send message form on thank you page after purchase to encourage buyer start dialog. */
  encourageStartPurchaseDialog: Scalars['Boolean']['output'];
  enrolmentCard?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** The number of followers for current user */
  followersCount: Scalars['Int']['output'];
  freePushupsLeft: Scalars['Int']['output'];
  freePushupsLimit: Scalars['Int']['output'];
  /** Indicates whether payment settings are hidden */
  hidePaymentSettings: Scalars['Boolean']['output'];
  /** internal id for current user */
  id: Scalars['Int']['output'];
  /** Whether client should ask user to add payment card */
  isAddPaymentCardRequired: Scalars['Boolean']['output'];
  isSeller: Scalars['Boolean']['output'];
  /** return True if viewer followed current user */
  isSubscribed: Scalars['Boolean']['output'];
  isTopSeller: Scalars['Boolean']['output'];
  /** whether a user is subject to any restrictions */
  isUserRestrictedByBankId: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** This field contains data about messages from sellers to subscribers */
  messageToSubscribers: MessageToSubscribersType;
  patronymic?: Maybe<Scalars['String']['output']>;
  /** settings of payments methods */
  paymentMethods: Array<PaymentMethodType>;
  paymentTransactions: PaymentTransactionTypeConnection;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Info about authorize platform. If info is null user must verify phone number */
  platformAuthorizeInfo?: Maybe<AuthorizePlatformType>;
  /** This field indicating reasons for not being able to create a post */
  postCannotCreateReason?: Maybe<Scalars['String']['output']>;
  /**
   *
   * Return paginated list of posts for particular user.
   *
   * For pagination we use seek approach, so u can't use reverse
   * pagination. hasPrevPage always is False.
   *
   */
  posts: PostTypeConnectionProxy;
  /**
   *
   * Return the number of posts created by the current user which are
   * available to the viewer.
   *
   * Note:
   *     user(id: 1) { posts ... } - return only posts which are
   *     available to the viewer
   *
   */
  postsAmount: Scalars['Int']['output'];
  /**
   *
   * Return paginated list of posts liked by viewer.
   *
   * For pagination we use seek approach, so u can't use reverse
   * pagination. hasPrevPage always is False.
   *
   */
  postsLiked: LikedPostTypeConnectionProxy;
  /**
   *
   * Return paginated list of posts saved by viewer.
   *
   * For pagination we use seek approach, so u can't use reverse
   * pagination. hasPrevPage always is False.
   *
   */
  postsSaved: SavedPostTypeConnectionProxy;
  /** represent the prepayment amount associated with order payment */
  prepayment: Scalars['String']['output'];
  receivingPaymentMethod?: Maybe<ReceivingPaymentMethod>;
  /** Indicates if the user needs to update their delivery settings */
  requestDeliverySettingsUpdate: Scalars['Boolean']['output'];
  /** Indicates if the user needs to update their payment settings */
  requestPaymentSettingsUpdate: Scalars['Boolean']['output'];
  sellerBadge: SellersBoostType;
  sellerRatingInfo?: Maybe<SellerRatingInfoType>;
  sendMessageToSubscribersAccess: Scalars['Boolean']['output'];
  /** shop name for current user (not unique) */
  shopName?: Maybe<Scalars['String']['output']>;
  showPhoneNumber: Scalars['Boolean']['output'];
  /** Amount of coins used for swap orders */
  swapCoins: Scalars['Int']['output'];
  /** Delivery services available for use with swap order */
  swapDeliveryServices: Array<DeliveryServiceDetailType>;
  /** Top seller indicators progress */
  topSellerIndicators?: Maybe<Array<TopSellerIndicatorType>>;
  url: Scalars['String']['output'];
  /** unique username for current user */
  username: Scalars['String']['output'];
};


export type ViewerTypePaymentTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterTransactions: TransactionFilterType;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ViewerTypePostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ViewerTypePostsLikedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ViewerTypePostsSavedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type WarehouseType = {
  __typename?: 'WarehouseType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: TypeOfWarehouse;
};

export type ErrorsDataFragment = { __typename?: 'GraphResponseError', field: string, messages: Array<{ __typename?: 'GraphErrorMessage', code: string, message: string }> } & { ' $fragmentName'?: 'ErrorsDataFragment' };

export type PostAuthorFragment = { __typename?: 'User', id: number, username: string, avatar: string, isSubscribed: boolean, followersCount: number } & { ' $fragmentName'?: 'PostAuthorFragment' };

export type PostDetailFragment = { __typename?: 'PostType', id: string, isLiked: boolean, isSaved: boolean, description: string, likesCount: number, savedCount: number, commentsCount: number, productsIds: Array<string>, tags: Array<string>, mediasUrls: Array<string>, type: PostKind, author: { __typename?: 'User', id: number, username: string, avatar: string, isSubscribed: boolean, followersCount: number }, products: Array<{ __typename?: 'ProductType', id: number, brandId?: number | null, url: string, name: string, thumbnail: string, slug: string, price: number, catalogId: number, rating?: number | null, statusTitle?: ProductVisibleStatusType | null, userStatusTitle: ProductUserStatusType, brand?: { __typename?: 'BrandType', id: number, name: string } | null }> } & { ' $fragmentName'?: 'PostDetailFragment' };

export type SeoHubDataFragment = { __typename?: 'SeoHubBlockType', title: string, blockType: SeoHubBlockTypeEnum, items: Array<{ __typename?: 'SeoHubItemType', title: string, url: string, pictureUrl?: string | null }> } & { ' $fragmentName'?: 'SeoHubDataFragment' };

export type BrandFilterDataFragment = { __typename?: 'BrandType', id: number, name: string, isUkrainian: boolean } & { ' $fragmentName'?: 'BrandFilterDataFragment' };

export const ErrorsDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"errorsData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphResponseError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode;
export const PostAuthorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"postAuthor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribed"}},{"kind":"Field","name":{"kind":"Name","value":"followersCount"}}]}}]} as unknown as DocumentNode;
export const PostDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"postDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}},{"kind":"Field","name":{"kind":"Name","value":"isSaved"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"postAuthor"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"migrate","block":false}}]}]}]}},{"kind":"Field","name":{"kind":"Name","value":"likesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savedCount"}},{"kind":"Field","name":{"kind":"Name","value":"commentsCount"}},{"kind":"Field","name":{"kind":"Name","value":"productsIds"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"mediasUrls"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activeOnly"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"statusTitle"}},{"kind":"Field","name":{"kind":"Name","value":"userStatusTitle"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"postAuthor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscribed"}},{"kind":"Field","name":{"kind":"Name","value":"followersCount"}}]}}]} as unknown as DocumentNode;
export const SeoHubDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"seoHubData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SeoHubBlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"blockType"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}}]}}]} as unknown as DocumentNode;
export const BrandFilterDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"brandFilterData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BrandType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isUkrainian"}}]}}]} as unknown as DocumentNode;